import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { motion } from 'framer-motion';
import { fadeInUp } from '@/motion/variants';

// Demo data for FOB vs CFR spread
const spreadData = [
  { month: 'Jan', fob: 285, cfr: 310, spread: 25 },
  { month: 'Feb', fob: 290, cfr: 315, spread: 25 },
  { month: 'Mar', fob: 275, cfr: 305, spread: 30 },
  { month: 'Apr', fob: 295, cfr: 320, spread: 25 },
  { month: 'May', fob: 300, cfr: 330, spread: 30 },
  { month: 'Jun', fob: 285, cfr: 315, spread: 30 },
  { month: 'Jul', fob: 290, cfr: 320, spread: 30 },
  { month: 'Aug', fob: 295, cfr: 325, spread: 30 },
  { month: 'Sep', fob: 285, cfr: 310, spread: 25 },
  { month: 'Oct', fob: 290, cfr: 315, spread: 25 },
  { month: 'Nov', fob: 295, cfr: 325, spread: 30 },
  { month: 'Dec', fob: 300, cfr: 335, spread: 35 }
];

const SignalsSpreadCard = () => {
  return (
    <motion.div
      variants={fadeInUp}
      initial="initial"
      animate="animate"
      className="bg-card/50 border border-border/50 p-6 rounded-lg shadow-sm"
    >
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-slate-900 mb-1">
          Indicative FOB vs CFR Spread
        </h3>
        <p className="text-sm text-slate-600">
          AMSUL Brazil ↔ NOLA (USD/MT)
        </p>
        <p className="text-xs text-slate-500 mt-1">
          Illustrative data - Not live pricing
        </p>
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={spreadData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis
              dataKey="month"
              tick={{ fontSize: 12, fill: '#64748b' }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 12, fill: '#64748b' }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '12px'
              }}
            />
            <Line
              type="monotone"
              dataKey="fob"
              stroke="#3b82f6"
              strokeWidth={2}
              dot={{ fill: '#3b82f6', strokeWidth: 2, r: 4 }}
              name="FOB Price"
            />
            <Line
              type="monotone"
              dataKey="cfr"
              stroke="#ef4444"
              strokeWidth={2}
              dot={{ fill: '#ef4444', strokeWidth: 2, r: 4 }}
              name="CFR Price"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 text-xs text-slate-500">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-blue-500 rounded"></div>
            <span>FOB (Free on Board)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-red-500 rounded"></div>
            <span>CFR (Cost & Freight)</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SignalsSpreadCard;
